import { render, staticRenderFns } from "./WarehouseReceiptItemsTable.vue?vue&type=template&id=a89c73ee&scoped=true"
import script from "./WarehouseReceiptItemsTable.vue?vue&type=script&lang=js"
export * from "./WarehouseReceiptItemsTable.vue?vue&type=script&lang=js"
import style0 from "./WarehouseReceiptItemsTable.vue?vue&type=style&index=0&id=a89c73ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89c73ee",
  null
  
)

export default component.exports